export enum NetworkSecurityInternetIncidentGetters {
    GET_FORM_VALUES = 'GET_FORM_VALUES',
    GET_OPEN_INCIDENTS = 'GET_OPEN_INCIDENTS',
}
